import { useMemo } from 'react';
import { formatSlotTime, formatSlotDay, slotToLocalTime, formatDateOnly } from '@utils/dayjs';

/**
 * React hook for accessing timezone-aware utility functions
 * All functions use Europe/Berlin timezone for consistency
 *
 * NOTE: This hook does NOT expose raw dayjs to enforce proper timezone handling
 * Use the provided utility functions instead
 *
 * @returns Object with utility functions for date formatting
 * @example
 * const MyComponent = () => {
 *   const { formatSlotTime, formatSlotDay, slotToLocalTime, formatDateOnly } = useDayjs();
 *   const slotTime = formatSlotTime(slotDate); // Formats UTC slot time to Berlin time
 *   const day = formatSlotDay(slotDate); // Gets day number in Berlin timezone
 *   const localTime = slotToLocalTime(slotDate); // Returns dayjs object in Berlin timezone
 *   const date = formatDateOnly(dateField); // Formats date-only fields (e.g., "15.01.2024")
 *   return <div>{slotTime}</div>;
 * };
 */
export const useDayjs = () => {
    return useMemo(
        () => ({
            formatSlotTime,
            formatSlotDay,
            slotToLocalTime,
            formatDateOnly,
        }),
        []
    );
};
